<template>
  <div class="news-page">
    <!-- Hero 区域 -->
    <section class="news-hero">
      <div class="hero-content">
        <h1>{{ $t('news.title') }}</h1>
        <p>{{ $t('news.subtitle') }}</p>
      </div>
    </section>

    <!-- 主容器 -->
    <div class="container">
      <!-- 新闻列表 -->
      <div class="news-container">
        <div
            v-if="newsList.length === 0"
            class="empty-state"
        >
          <p>{{ $t('news.empty') }}</p>
        </div>

        <div
            v-for="news in newsList"
            :key="news.id"
            class="news-card"
        >
          <!-- 新闻图片 -->
          <div class="news-image">
            <img
                :src="news.image"
                :alt="news.title"
                @error="handleImageError"
            >
            <div class="image-overlay"></div>
          </div>

          <!-- 新闻内容 -->
          <div class="news-content">
            <!-- 元信息 -->
            <div class="news-meta">
              <span class="news-date">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <rect x="3" y="4" width="18" height="18" rx="2"></rect>
                  <path d="M16 2v4M8 2v4M3 10h18"></path>
                </svg>
                {{ news.date || '2025年' }}
              </span>
              <span class="news-category">{{ news.category || '新闻' }}</span>
            </div>

            <!-- 标题 -->
            <h2 class="news-title">{{ news.title }}</h2>

            <!-- 描述 -->
            <p class="news-desc">{{ news.desc }}</p>

            <!-- 底部信息 -->
            <div class="news-footer">
              <div class="author-info">
<!--                <span class="author-label">{{ $t('news.card.postedBy') }}</span>-->
                <span class="author-name">{{ news.author }}</span>
              </div>
              <button
                  class="view-btn"
                  @click="goToDetail"
              >
                <span>{{ $t('news.card.viewMore') }}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fastly_news from '@/assets/images/fastly_news.png'

export default {
  name: 'NewsPage',
  data() {
    return {
      // newsList: [
      //   {
      //     id: 1,
      //     title: this.$t('news.newsList.title'),
      //     desc: this.$t('news.newsList.desc'),
      //     author: this.$t('news.newsList.author'),
      //     date: this.$t('news.newsList.date'),
      //     category: this.$t('news.newsList.category'),
      //     image: fastly_news
      //   }
      // ]
    }
  },
  computed: {
    newsList() {
      return [
        {
          id: 1,
          title: this.$t('news.newsList.title'),
          desc: this.$t('news.newsList.desc'),
          author: this.$t('news.newsList.author'),
          date: this.$t('news.newsList.date'),
          category: this.$t('news.newsList.category'),
          image: fastly_news
        }
      ]
    }
  },
  methods: {
    handleImageError(e) {
      // 图片加载失败时的处理
      e.target.style.display = 'none'
    },
    goToDetail() {
      // 跳转到新闻详情页
      this.$router.push({
        name: 'FecNewsDetail',
      })
    }
  }
}
</script>

<style scoped>
.news-page {
  background-color: var(--background-light);
  min-height: 100vh;
}

/* Hero 区域 */
.news-hero {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  color: white;
  position: relative;
  overflow: hidden;
}

.news-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1), transparent 50%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 600px;
  margin: 0 auto;
}

.news-hero h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.news-hero p {
  font-size: 1.1rem;
  opacity: 0.9;
  line-height: 1.6;
  font-weight: 300;
}

/* 容器 */
.container {
  max-width: 520px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 新闻容器 */
.news-container {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 3rem 0;
}

/* 单条新闻卡片 */
.news-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  flex-direction: column;
}

.news-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 32px rgba(102, 126, 234, 0.15);
}

/* 新闻图片 */
.news-image {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
}

.news-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.news-card:hover .news-image img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.02) 100%);
  pointer-events: none;
}

/* 新闻内容 */
.news-content {
  padding: 32px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 元信息 */
.news-meta {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  align-items: center;
}

.news-date {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #999;
  opacity: 0.8;
}

.news-date svg {
  opacity: 0.6;
}

.news-category {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.08), rgba(118, 75, 162, 0.08));
  color: var(--primary-color);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

/* 标题 */
.news-title {
  font-size: 22px;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
  line-height: 1.5;
  transition: color 0.3s;
}

.news-card:hover .news-title {
  color: var(--primary-color);
}

/* 描述 */
.news-desc {
  font-size: 15px;
  color: #555;
  line-height: 1.8;
  margin-bottom: 24px;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 底部信息 */
.news-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  gap: 16px;
}

.author-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.author-label {
  font-size: 12px;
  color: #999;
}

.author-name {
  font-size: 13px;
  color: #666;
  font-weight: 500;
}

/* 查看按钮 */
.view-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.view-btn:hover {
  transform: translateX(4px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
}

.view-btn:active {
  transform: translateX(2px);
}

.view-btn svg {
  transition: transform 0.3s;
}

.view-btn:hover svg {
  transform: translateX(2px);
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 100px 20px;
  color: #999;
  font-size: 16px;
}

/* 响应式 */
@media (max-width: 768px) {
  .news-hero {
    padding: 3rem 1.5rem;
  }

  .news-hero h1 {
    font-size: 1.8rem;
  }

  .news-hero p {
    font-size: 1rem;
  }

  .container {
    max-width: 100%;
    padding: 0 16px;
  }

  .news-container {
    gap: 24px;
    padding: 2rem 0;
  }

  .news-image {
    height: 200px;
  }

  .news-content {
    padding: 24px;
  }

  .news-title {
    font-size: 18px;
  }

  .news-desc {
    font-size: 14px;
    margin-bottom: 16px;
  }

  .news-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .view-btn {
    width: 100%;
    justify-content: center;
  }
}

/* 暗色主题支持 */
@media (prefers-color-scheme: dark) {
  .news-card {
    background: #1a1a1a;
  }

  .news-title {
    color: #f0f0f0;
  }

  .news-desc {
    color: #bbb;
  }

  .news-footer {
    border-top-color: #333;
  }

  .author-label {
    color: #777;
  }

  .author-name {
    color: #999;
  }
}
</style>